jsonpFunctionUIB([4],{

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        var trackExitIntent = function (options, callback) {
	
	            function isTouchDevice() {
	                return (('ontouchstart' in window) ||
	                    (navigator.maxTouchPoints > 0) ||
	                    (navigator.msMaxTouchPoints > 0));
	            }
	
	            if (isTouchDevice()) {
	                // no exit intent on touch devices
	                return;
	            }
	            var _html = document.documentElement,
	                maxY = 50;
	
	            if (window.uResponses.exitIntentTracked) {
	                callback(null);
	                return;
	            }
	
	            window.uResponses.exitIntentTracked = true;
	            _html.addEventListener('mouseleave', handleMouseleave);
	            _html.addEventListener('mouseenter', handleMouseenter);
	
	            var intentDetected = false;
	
	            function handleMouseleave(e) {
	                if (e.clientY < maxY && !intentDetected) {
	                    var intent = 'Exit';
	                    if (e.clientX < 100) {
	                        intent = 'Back';
	                    }
	                    uDash.saveMeta(intent + ' Intent Section', uDash.shared._sstorage.get('lastSection'));
	                    intentDetected = true;
	                }
	            }
	
	            function handleMouseenter() {
	                if (intentDetected) {
	                    uDash.saveMeta('Cancelled Intent Section', uDash.shared._sstorage.get('lastSection'));
	                    intentDetected = false;
	                }
	            }
	
	            callback(null);
	        }
	        return trackExitIntent;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })

});


// WEBPACK FOOTER //
// responses/data-collection/trackExitIntent/trackExitIntent.js